import SeamlyBaseError from './seamly-base-error'

export default class SeamlySessionExpiredError extends SeamlyBaseError {
  constructor(originalError?: any, ...params) {
    super(originalError, ...params)

    this.name = 'SeamlySessionExpiredError'
    this.action = 'reset'
  }
}
